export default "__VITE_ASSET__CN83$H4c__"